import React, { useEffect, useMemo, useRef } from "react";
import { observer } from "mobx-react";
import { AssociatedDocumentEditionViewStore } from "../../store";
import { AssociatedDocumentEditionView } from "./AssociatedDocumentEditionView";
import { useRootStore } from "../../../../store/contexts/RootStoreContext";
import { Box, CircularProgress } from "@mui/material";

export type AssociatedDocumentEditionDrawerContentProps = {
  entityId: string;
  mode?: "view" | "update";
};

export const AssociatedDocumentEditionDrawerContent: React.FC<AssociatedDocumentEditionDrawerContentProps> =
  observer(({ entityId, mode = "view" }) => {
    const rootStore = useRootStore();
    const viewInitializedRef = useRef<string | null>(null);

    const viewStore = useMemo(() => {
      const s = new AssociatedDocumentEditionViewStore(rootStore);
      s.isDrawerMode = true;
      return s;
    }, [rootStore]);

    useEffect(() => {
      if (
        mode === "view" &&
        entityId &&
        viewInitializedRef.current !== entityId
      ) {
        viewInitializedRef.current = entityId;
        viewStore.initialize({ id: entityId });
      }
    }, [entityId, mode, viewStore]);

    if (
      viewStore.status === "processing" ||
      viewStore.status === "uninitialized"
    ) {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 200,
          }}
        >
          <CircularProgress />
        </Box>
      );
    }

    return (
      <AssociatedDocumentEditionView
        associatedDocumentEditionViewStore={viewStore}
      />
    );
  });
